import { render } from "./ProjectLogo.vue?vue&type=template&id=5974294a&scoped=true"
import script from "./ProjectLogo.vue?vue&type=script&lang=js"
export * from "./ProjectLogo.vue?vue&type=script&lang=js"

import "./ProjectLogo.vue?vue&type=style&index=0&id=5974294a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_48ac5cde7c36a6fbb3736f36e5a55bfb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5974294a"]])

export default __exports__